<template>
  <div class="navber-container">
    <div class="examhomebanner" :style="backgroundImage" @click="goToHome"></div>
    <div class="navbar" id="headbar">
      <div class="hospital" >
        <img src="../../../assets/image/logo.png" alt="" @click="goToHome">
      </div>
      <div class="head-nav">
        <ul>
          <li>
            <h3><a href="javascript:0;">关于协会</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/lists/37/">协会简介</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/38/">章程</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/39/">发展历程</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/40/">组织架构</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/41/">联系我们</a></dd>
            </dl>
          </li>
          <li>
            <h3><a href="javascript:0;">理事会</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/lists/3/">顾问委员会</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/4/">会长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/42/">副会长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/43/">特邀副会长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/141/">总协调人</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/44/">监事长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/48/">秘书长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/280/">常务副秘书长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/151/">副秘书长</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/45/">常务理事</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/46/">理事</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/47/">在线入会</a></dd>
              <dd><a href="http://www.ceea500.org.cn/login?denglu=1">会员登录</a></dd>
            </dl>
          </li>
          <li>
            <h3><a href="javascript:0;">协会动态</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/lists/14/">新闻·动态</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/49/">重要通知</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/27/">产经动态</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/51/">政企座谈会</a></dd>
              <dd><a href="http://www.ceea500.org.cn/case/lists/85/">媒体报道</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/789/">会员园地</a></dd>
            </dl>
          </li>
          <li>
            <h3><a href="javascript:0;">评价研究</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/bangdannew/数字经济企业TOP500/2022/">榜单</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/54/">行研</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/53/">报告</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/270/">团标</a></dd>
            </dl>
          </li>
          <li>
            <h3><a href="javascript:0;">论坛-培训</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/lists/56/">中国企业发展高层论坛</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/57/">合作论坛</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/58/">工信部中小企业领军人才培训</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/146/1/26/">新经济企业TOP500发布会</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/269/1/25/">数字经济企业TOP500发布会</a></dd>
            </dl>
          </li>
          <li>
            <h3><a href="javascript:0;">分支机构</a></h3>
            <dl>
              <dd><a href="http://www.ceea500.org.cn/news/lists/62/">二级委员会</a></dd>
              <dd><a href="http://www.ceea500.org.cn/news/lists/61/">投资参股</a>></dd>
            </dl>
          </li>
          <!-- <li>
            <h3><a href="http://www.ceea500.org.cn/news/lists/135/">信用评价</a></h3>
            <dl> 
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/135/">公益培训活动通知</a>
              </dd>
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/136/">图解信用</a>
              </dd>
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/137/">政策法规</a>
              </dd>
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/138/">诚信文化</a>
              </dd>
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/139/">信用承诺单位</a>
              </dd>
              <dd>
                <a href="http://www.ceea500.org.cn/news/lists/160/">信用等级结果公示</a>
              </dd>
            </dl>
          </li> -->
        </ul>
      </div>
      <div class="head-search">
        <input type="text" id="kw" class="input-text" v-model="input_name" placeholder="请输入您要搜索的内容" @keydown.enter.native="searchEnterFun($event)">
        <button type="button" class="btn-so" @click="inputClick">
          <img src="../../../assets/image/icon-searh.png" alt="" />
          <span>搜索</span>
        </button>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  components: {

  },
  data(){
    return{
      is_show:true,
      backgroundImage:{ 
        backgroundImage: 'url(' + require('../../../assets/image/examinfotop.jpg') + ')',
      },
      input_name: ''
    }
  },
    watch: {
    $route() {
      this.setCurrentRoute();
    }
  },
  computed: {
   

    // avatar() {
    //   return this.$store.state.user.realAvatar
    // },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      return '' || path;
    },
  },
 
  mounted() {
 
  },
  created(){
    this.setCurrentRoute();
  },
  methods: {
    // 回车键点击
    searchEnterFun(e){
      var keyCode = window.event?e.keyCode:e.which;
      if(keyCode == 13){
        this.inputClick();
      }
    },
    inputClick(){
      let input_name = this.input_name;
      this.$router.push({
        path:'/newsHome/search',
        query:{
          search: input_name
        }
      })
    },
    clickItems(){
      this.$router.push({
        path:'/newsHome/AboutAssociation',
        query:{
        }
      })
    },  
    setCurrentRoute() {
      console.log(this.$route.path); 
      if(this.$route.path != '/newsHome/news'){
        this.is_show = false
      }else{
        this.is_show = true
      } 
    },
    goToHome(){
      this.$router.push({
        path:'/home',
        query:{
        }
      })
    },
    search(e){

    },
    
  },
};
</script>

<style lang="scss" scoped>
.navber-container{
  color: #fff;
  margin: 0 auto;
}
.navbar {
  margin: 0 auto;
  width: 100%;
  height: 94px;
  position: relative;
  background: #2E2E2E;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hospital{
  width: 330px;
  height: 100%;
  display: flex;
  align-items: center;
}
.hospital img{
  width: 100%;
}
.head-nav {
  height: 100%;
  flex: 1;
  padding: 0 20px;
  ul {
    height: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
  li {
    display: inline-block;
    height: 94px;
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 3px;
    padding: 0 10px;
    dl {
      position: absolute;
      width: 200px;
      left: 50%;
      margin-left: -100px;
      padding: 0 15px;
      height: auto;
      top: 80px;
      background: #fff;
      border-radius: 15px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
      overflow: hidden;
      transition: 0.3s;
      display: none;
      z-index: 999;
    }
  }
  h3 {
    font-size: 18px;
    font-weight: normal;
    a {
      display: block;
      height: 36px;
      width: 91px;
      text-align: center;
      font-size: 15px;
      color: #fff;
      line-height: 36px;
      border-radius: 50px;
    }
  }
 
}
.head-nav li dl {
  bottom: auto;
  top: 80px;
}
.head-nav li.on h3 a, .head-nav li:hover h3 a {
  color: #fff;
  background: #BB0000;
}
.head-nav li:hover dl {
  display: block;
  height: auto;
  overflow: visible;
}
.head-nav dl a:hover {
  background: #BB0000;
  color: #fff;
}
.head-nav dl dd:nth-of-type(1) {
  padding-top: 15px;
}
.head-nav dl dd:nth-last-of-type(1) {
  padding-bottom: 15px;
}
.head-nav dl a {
  display: block;
  text-align: center;
  line-height: 36px;
  font-size: 13px;
  color: #636363;
  border-radius: 5px;
}
.right-items-box{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.right-items-box div{
  padding: 0 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;
}

.examhomebanner{
  width: 100%;
  height: 350px;
  margin: 0 auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
.head-search {
  position: absolute;
  width: 330px;
  height: 36px;
  right: 26px;
  top: 50%;
  transform: translateY(-50%);
}
.head-search .input-text {
  position: absolute;
  height: 36px;
  padding: 10px;
  line-height: 16px;
  background: #fff;
  left: 0;
  width: 250px;
  color: #5F5F5F;
  font-size: 14px;
}
.head-search .btn-so {
  position: absolute;
  right: 0;
  top: 0;
  width: 80px;
  height: 36px;
  line-height: 36px;
  background: #BB0000;
  text-align: center;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.head-search .btn-so img{
  width: 16px;
  height: 16px;
}
// 0.71
@media (max-width: 1380px){
    .navbar{
      height: 65px;
    }
    .hospital{
      width: 234px;
    }
    .head-nav{
      li{
        height: 65px;
      }
      h3 {
        font-size: 14px;
        font-weight: normal;
      }
    }
    .head-nav li dl {
      bottom: auto;
      top: 60px;
    }
  }
</style>
